import React, { useEffect, useState } from "react";
import FeatureCardContent from "@shared/FeatureCardContent/FeatureCardContent";
import pricingListIcon from "@icons/pricing-list-icon.svg";
import { getSeasonalTheme } from "@lib/seasonalTheme";
import "./CapTableCard.css";

const baseHolders = [
  {
    name: "Common - Founders",
    shares: 8000000,
    pct: 64.0,
    color: "var(--color-secondary)",
  },
  {
    name: "Option Pool (unallocated)",
    shares: 1250000,
    pct: 10.0,
    color: "var(--color-tertiary)",
  },
  {
    name: "Seed - Ridge Park",
    shares: 1500000,
    pct: 12.0,
    color: "var(--color-primary)",
  },
  {
    name: "Seed - Highland Angels",
    shares: 900000,
    pct: 7.2,
    color: "var(--color-primary-amber)",
  },
  { name: "Advisors", shares: 350000, pct: 2.8, color: "var(--color-gray-400)" },
  { name: "Available", shares: 500000, pct: 4.0, color: "var(--color-gray-300)" },
];

const formatShares = (n) =>
  n.toLocaleString("en-US", { maximumFractionDigits: 0 });

function CapTableCard() {
  const theme = getSeasonalTheme();
  const [highlight, setHighlight] = useState(-1);

  // Rows are read top to bottom once, then the table rests. It used to cycle the highlight forever.
  useEffect(() => {
    let i = 0;
    const id = setInterval(() => {
      if (i >= baseHolders.length) {
        setHighlight(-1);
        clearInterval(id);
        return;
      }
      setHighlight(i);
      i += 1;
    }, 650);
    return () => clearInterval(id);
  }, []);

  return (
    <article
      className="venture-card captable-card"
      style={{ "--card-monet": `url(${theme.paintings.capTable})` }}
    >
      <FeatureCardContent
        className="feature-card-content--startup-card"
        badgeTitle="Cap table"
        title="A cap table that updates itself as the round closes."
        text="Every signed SAFE, option grant, and secondary flows into one source of truth - with pro-forma scenarios ready before the next term sheet."
        icon={<img className="venture-card__feature-icon" src={pricingListIcon} alt="" />}
      >
        <div className="feature-card-content__tags">
          <span className="feature-card-content__tag">Fully diluted</span>
          <span className="feature-card-content__tag">Pro-forma</span>
          <span className="feature-card-content__tag">409A-ready</span>
        </div>
      </FeatureCardContent>

      <div className="venture-card__pane venture-card__pane--visual">
        <div className="venture-mock captable-mock">
          <div className="venture-mock__header">
            <span>Cap table - Apex Robotics</span>
            <span className="captable-mock__live">
              <span className="captable-mock__live-dot" />
              Live
            </span>
          </div>
          <div className="venture-mock__body captable-mock__body">
            <div className="captable-mock__bar" aria-hidden="true">
              {baseHolders.map((h, i) => (
                <span
                  key={h.name}
                  className={`captable-mock__bar-seg ${i === highlight ? "is-active" : ""}`}
                  style={{
                    flexBasis: `${h.pct}%`,
                    background: h.color,
                  }}
                />
              ))}
            </div>
            <table className="captable-mock__table">
              <thead>
                <tr>
                  <th>Holder</th>
                  <th>Shares</th>
                  <th>FD %</th>
                </tr>
              </thead>
              <tbody>
                {baseHolders.map((h, i) => (
                  <tr key={h.name} className={i === highlight ? "is-highlight" : ""}>
                    <td>
                      <span
                        className="captable-mock__swatch"
                        style={{ background: h.color }}
                      />
                      {h.name}
                    </td>
                    <td>{formatShares(h.shares)}</td>
                    <td>{h.pct.toFixed(1)}%</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </article>
  );
}

export default CapTableCard;
